import { requestDataCenter } from './client-core/index';
import { reportJSInfo } from '@max/meituan-uni-report';
import { AntiReqTool } from '@nibfe/h5guard-request';
import { request } from '@max/meituan-uni-network';
const isWeb = true;
export const AJAX_ERROR_NAME = '网络错误';
/**
 * 将对象转换为 URL 查询参数字符串
 * @param params 参数对象
 * @returns URL 参数字符串，如 "key1=value1&key2=value2"
 */
export function objectToParams(params) {
    if (!params || typeof params !== 'object') {
        return '';
    }
    return Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '').map(([key, value]) => {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(String(value));
        return `${encodedKey}=${encodedValue}`;
    }).join('&');
}
export function requestCardData(props, cardParams) {
    const { disableRequestCombine = false } = props;
    const params = {
        componentProps: Object.assign({ moduleType: 'max-comprehensive-card', 
            // 数据源组件名称
            moduleVersion: '2.0.6', 
            // 兼容鸿蒙TeX组件版本
            uid: 'comp_79ec43e0-242d-4207-9972-97b6703c093b' }, props),
        requestParams: {
            body: {
                moduleParam: cardParams
            },
            // http://api.hotel.test.sankuai.com/flagship/data/center/  测试环境
            // https://ihotel.meituan.com/flagship/data/center/  线上
            devBasePath: 'https://ihotel.meituan.com/flagship/data/center/'
        }
    };
    return new Promise((resolve, reject) => {
        if (!disableRequestCombine) {
            requestDataCenter(Object.assign(Object.assign({}, params), { isCombo: true, 
                // 聚合请求
                comboCallback: (res) => {
                    if (!res) {
                        resolve(null);
                    }
                    else {
                        resolve(res);
                    }
                } })).catch(() => {
                reject(new Error('网络开小差了，请重试'));
            });
        }
        else {
            requestDataCenter(Object.assign(Object.assign({}, params), { isCombo: false // 聚合请求
             })).then((res) => {
                if (!res) {
                    reject(new Error('网络开小差了，请重试'));
                }
                else {
                    resolve(res);
                }
            }).catch(() => {
                reject(new Error('网络开小差了，请重试'));
            });
        }
    });
}
const API_MAP = {
    PROD: 'https://ihotel.meituan.com',
    TEST: 'https://api.hotel.test.meituan.com'
};
export const API_PATH = {
    STATIC_SUPPLY_DELIVERY: '/landing/page/query/simpleShelf/data'
};
/**
 * 迁移新接口使用，接口文档：https://km.sankuai.com/collabpage/2734836139
 * @param requestConfig
 * @returns
 */
export function fetchData(requestConfig) {
    const { path, method, params } = requestConfig;
    let finalRequestParams = params;
    let url = `${API_MAP.PROD}${path}`;
    if (true) {
        try {
            const antiReq = new AntiReqTool({
                autoFillParams: true
            });
            // @ts-ignore
            finalRequestParams = antiReq.addCommonParams(finalRequestParams);
            // @ts-ignore
            if ((finalRequestParams === null || finalRequestParams === void 0 ? void 0 : finalRequestParams.token) && (finalRequestParams === null || finalRequestParams === void 0 ? void 0 : finalRequestParams.userId) && (finalRequestParams === null || finalRequestParams === void 0 ? void 0 : finalRequestParams.utmParams)) {
                // @ts-ignore
                url = `${API_MAP.PROD}${path}?userId=${finalRequestParams.userId}&token=${finalRequestParams.token}&${objectToParams(finalRequestParams.utmParams)}&${objectToParams(finalRequestParams.riskParams)}`;
            }
        }
        catch (_a) {
            reportJSInfo({
                level: 'info',
                content: '请求加上反爬参数错误',
                secCategory: 'ajaxError'
            }).catch();
        }
    }
    return new Promise((resolve, reject) => {
        request({
            url,
            data: Object.assign({}, finalRequestParams),
            method,
            header: {
                'content-type': 'application/json'
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'hotel'
            },
            success(res) {
                if (res === null || res === void 0 ? void 0 : res.data) {
                    const templateRes = res === null || res === void 0 ? void 0 : res.data;
                    resolve(templateRes);
                }
                else {
                    reject(new Error(AJAX_ERROR_NAME));
                }
            },
            fail(error) {
                reject(error);
            }
        });
    });
}
